module.exports = function($scope) {
	$scope.$on('DashboardContainerController:getCurrentWidget', function(e, widget, preset) {
		$scope.readonlyQueryString = "";
		var datasourceQuery = "";
		var query = "";

		if(!!widget.model.datasource){
			datasourceQuery = widget.model.datasource.query;
		}

		if(!$scope.isEmpty(widget.ctx.data.query)){
			query = widget.ctx.data.query.replace(/^\s*\|/, '');
		}

		if(!$scope.isEmpty(datasourceQuery)){
			$scope.readonlyQueryString += datasourceQuery;
		}

		if(!$scope.isEmpty(query)){
			if(!$scope.isEmpty($scope.readonlyQueryString)){
				$scope.readonlyQueryString += " | ";
			}
			$scope.readonlyQueryString += query;
		}

		$scope.ctx = widget.ctx;
		$scope.$apply();
	});

	$scope.isEmpty = function(str){
		return !str || str.length == 0;
	}
}


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/WidgetPropertyReadonlyController.js